import { History } from 'history';

export function clearQueryParam(queryToClear: string, history: History): void {
  const { location } = history;
  const nextSearch = new URLSearchParams(location.search);

  nextSearch.delete(queryToClear);

  const nextLocation = {
    ...location,
    search: nextSearch.toString(),
  };

  history.replace(nextLocation);
}
